
function EditorText(){

    $('.image-half').closest('p').addClass('images--half');

}